export const AnalyticsConstant: any= {
  hissa_logo_button: "hissa_logo_button",
  book_a_demo_button: "book_a_demo_button",
  change_password_button: "change_password_button",
  forgot_password_button: "forgot_password_button",
  logout_button: "logout_button",
  login_button: "login_button",
  google_login_button: "google_login_button",
  generate_otp_button: "generate_otp_button",

  captable_redirect_button: "captable_redirect_button",
  esop_redirect_button: "esop_redirect_button",
  investor_redirect_button: "investor_redirect_button",
  taskManager_redirect_button: "taskManager_redirect_button",

  captable_explore_button: "captable_explore_button",
  esop_explore_button: "esop_explore_button",
  investor_explore_button: "investor_explore_button",
  taskManager_explore_button: "taskManager_explore_button",

  shared_content_view_button: "shared_content_view_button",
};
